
// CSS
 import React, { useEffect, useRef } from "react";
 import gsap from "gsap";
  import { ScrollTrigger } from "gsap/ScrollTrigger";
 import Routers from './routers';

 import LenisScroll from './component/smoothscroll'
// import useGsapAnimations from './component/animation';

import './App.css';
import 'lenis/dist/lenis.css'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";





gsap.registerPlugin(ScrollTrigger);


function App() {
  LenisScroll()
  // useGsapAnimations()

  const containerRef = useRef(null);
  
    useEffect(() => {
      const ctx = gsap.context(() => {
        const sections = gsap.utils.toArray(".section-scroll-animation");
  
        sections.forEach((section) => {
          gsap.from(section, {
            y: 200,
            opacity: 0,
            duration: 5,
           ease: "power1.inOut",
            scrollTrigger: {
              trigger: section,
              start: "top 120%",
              end: "top center",
              scrub: 2,
              toggleActions: "play none none none",
            },
          });
        });
      }, containerRef);
  
      return () => ctx.revert();
    }, []);
  
  
    useEffect(() => {
      const ctx = gsap.context(() => {
        gsap.utils.toArray(".first-story-section").forEach((el) => {
          gsap.fromTo(
            el,
            {
              width: "90%",
              borderRadius: "34px",
              y: 120,
            },
            {
              width: "100%",
              borderRadius: "0px",
              y: 0,
              ease: "none",
              scrollTrigger: {
                trigger: el,
                start: "top 80%",
                end: "top 10%",
                scrub: 1,
              },
            }
          );
        });
      }, containerRef);
  
      return () => ctx.revert(); 
    }, []);


  return (
    <div className="App" ref={containerRef}>
        <Routers/>     
    </div>

  );
}

export default App;
